import { render, staticRenderFns } from "./FormPageTemplate.vue?vue&type=template&id=a29ec2d6&scoped=true&"
import script from "./FormPageTemplate.vue?vue&type=script&lang=js&"
export * from "./FormPageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./FormPageTemplate.vue?vue&type=style&index=0&id=a29ec2d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a29ec2d6",
  null
  
)

export default component.exports